import styled from '@emotion/styled'
import '../../variables.scss'

export const CheckBox = styled.div<{margin?: string}>`
  cursor: pointer;
  margin: ${({ margin }) => (margin ? margin : '0')};
`

export const CheckBoxIcon = styled.div<{
  color: string
}>`
  margin-right: 0.5em;
  font-size: 1.2em;
  color: ${({ color }) => (color ? color : '#005cdb')};
  &.checked {
    color: ${({ color }) => (color ? color : '#005cdb')};
  }
  display: inline;
`

export const CheckBoxLabel = styled.label<{
  color: string
}>`
  line-height: 1.4;
  color: ${({ color }) => (color ? color : 'rgba(0,0,0,0.5)')};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  position: relative;
  top: -2px;
`

export const HelpContainer = styled.div<{
  open: boolean
}>`
  position: relative;
  margin-left: 0.5em;
  display: inline-block;
`

export const HelpIcon = styled.div<{
  color: string
}>`
  color: ${({ color }) => (color ? color : '#005cdb')};
`

export const HelpText = styled.div<{
  color: string
  backgroundColor: string
  open: boolean
}>`
  display: ${({ open }) => (open ? 'block' : 'none')};
  position: absolute;
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : 'white'};
  z-index: 1;
  border: 1px solid #005cdb;
  width: 20em;
  left: 1.5em;
  top: 0;
  padding: 1em;
`
